import * as React from 'react';
import { useDispatch } from 'react-redux';
import { RoundButton } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import { TThunkDispatch } from '../../types/redux/thunk';
import { deleteNewbuildingFromComparison } from '../../actions/newbuildingsCompare';

export interface INewbuildingDeleteButtonProps {
  newbuildingId: number;
  size?: React.ComponentProps<typeof RoundButton>['size'];
  iconColor?: React.ComponentProps<typeof IconActionClose16>['color'];
}

export const NewbuildingDeleteButton: React.FC<INewbuildingDeleteButtonProps> = ({
  newbuildingId,
  size = 'M',
  iconColor,
}) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = React.useCallback(() => {
    dispatch(deleteNewbuildingFromComparison({ newbuildingId }));
  }, [dispatch, newbuildingId]);

  return (
    <RoundButton
      data-testid="newbuilding-delete-button"
      icon={<IconActionClose16 color={iconColor} />}
      onClick={handleClick}
      size={size}
      theme="light"
      title="Удалить из сравнения"
    />
  );
};
